import {
  ConfirmModalArgs,
  useConfirmModal,
} from '@/components/ConfirmationModal';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export const useDeleteConfirm = () => {
  const { t } = useTranslation();

  const args: ConfirmModalArgs = useMemo(
    () => ({
      title: t('transaction_items.confirm.delete.title'),
      body: t('transaction_items.confirm.delete.message'),
      cancelButtonProps: {
        isTertiary: true,
        children: t('cancel'),
        testId: 'transaction_items.confirm.delete.button.return',
      },
      okButtonProps: {
        isSecondary: true,
        color: 'danger',
        children: t('delete'),
        testId: 'transaction_items.confirm.delete.button.confirm',
      },
    }),
    [t]
  );

  return useConfirmModal(args);
};
